
export enum FilterType {
    Statut = 'Statut', 
    Categorie = 'Catégorie',
    Date = 'Date'
}